import React from "react";
import { Button, Stack} from "@mui/material";
import InstagramIcon from '@mui/icons-material/Instagram';

export default function Footer() {
    return (
        <Stack
            key={5}
            direction="column"
            spacing={8}
            component="footer"
            sx={{
                scrollSnapAlign: "start",
                backgroundColor: "black",
                color: "#fff",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
            }}
        >
            <div>

            <p>© 2025 City St George Aerospace Society | Contact: rocketrysoc@city.ac.uk if you have any questions.</p>
                <Button variant={"text"} startIcon={<InstagramIcon />} href="https://www.instagram.com/cityaerospace/">
                    Follow us on Instagram
            </Button>
                <br/>

            </div>

        </Stack>
    )

};